import React, { Fragment, useEffect, useState } from 'react';
import { Button, Col, Container, Input, Row, Table } from 'reactstrap';
import { toast } from "react-toastify";
import _ from 'lodash';
import { FilterSelect, ServiceThreadSpinner } from '.';
import { api, filterHelpers } from '../utils';
import { confirmAlert } from "react-confirm-alert";

export default function ManageLateReasons() {
   const ALL_OPTS = { value: 0, label: "-- Select --", isActive: false };
   const LATE_MODEL = { reasonId: 0, reason: "", isActive: true };
   const [lateRsn, setLateRsn] = useState(LATE_MODEL);
   const [rsnList, setRsnList] = useState([]);
   const [filters, setFilters] = useState([
      { filterName: "lateReason", value: ALL_OPTS }
   ]);
   const [editRsn, setEditRsn] = useState("");
   const [newRsn, setNewRsn] = useState("");
   const [origRsn, setOrigRsn] = useState("");
   const [spinLateRsn, setSpinLateRsn] = useState(true);

   useEffect(() => {
      runQuery();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   useEffect(() => {
      if (!lateRsn || lateRsn.reasonId === 0)
         return; // reason was reset to initial state

      if (!editRsn || editRsn.length < 1)
         return; // Not editing       

      if (lateRsn.reason === origRsn)
         return; // No change made to reason being edited

      if (lateRsn.reason.length < 3) { // Do we need this?
         toast.error("Reason description must be at least 3 characters");
         return;
      }
      UpdateLateReason();
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [lateRsn])

   function ActivateLateReason() {
      if (!lateRsn || lateRsn.reasonId === 0) {
         toast.error("Please select a reason to activate");
         return;
      }

      setSpinLateRsn(true);
      api.post(`Sales/ActivateLateReason/${lateRsn.reasonId}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Late Shipment Reason activated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinLateRsn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinLateRsn(false);
         });
   }

   function DeleteLateReason() {
      setSpinLateRsn(true);
      api.post(`Sales/DeleteLateReason/${lateRsn.reasonId}`)
         .then((response) => {
            if (response.data.success) {
               toast.success("Late Shipment Reason was successfully deleted or made inactive!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinLateRsn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinLateRsn(false);
         });
   }

   function onLateRsnChange(newFilterValue) {
      let newFilters = filterHelpers.getFilters(filters, newFilterValue);
      setFilters(newFilters);

      setNewRsn(""); // Clear any lingering values
      if (newFilterValue.value === 0) {
         setLateRsn(LATE_MODEL);
         setOrigRsn("");
         setEditRsn("");
      }
      else { // Get the reason to be edited
         const d = _.find(rsnList, (x) => x.value === newFilterValue.value);
         let changes = Object.assign({}, lateRsn);
         changes.reason = newFilterValue.label;
         changes.isActive = d.isActive;
         changes.reasonId = newFilterValue.value;
         setLateRsn(changes);
         setOrigRsn(newFilterValue.label);
         setEditRsn(newFilterValue.label);
      }
   }

   function onLateRsnUpdate() {
      let changes = Object.assign({}, lateRsn);
      changes.reason = editRsn
      setLateRsn(changes);
   }

   function runQuery() {
      setSpinLateRsn(true);
      api
         .fetch(`Sales/GetLateShipReasons`)
         .then((response) => {
            if (response.data.success) {
               const lsrList = _.concat([ALL_OPTS],
                  _.map(response.data.reasons, (d) => ({
                     value: d.reasonId,
                     label: d.reason,
                     isActive: d.isActive
                  })));
               return { lsrList: lsrList };
            } else {
               toast.error(response.data.message);
            }
         })
         .then(({ lsrList }) => {
            setRsnList(lsrList);
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
         })
         .finally(() => {
            setEditRsn("");
            setOrigRsn("");
            setNewRsn("")
            setLateRsn(LATE_MODEL);
            setSpinLateRsn(false);
         });
   }

   function SaveNewRsn() {
      if (!newRsn || newRsn.length < 1) {
         toast.error("Please provide a reason description");
         return;
      }
      if (newRsn.length < 3) {
         toast.error("Reason description must be at least 3 characters");
         return;
      }
      let payload = LATE_MODEL;
      payload.reason = newRsn;
      
      setSpinLateRsn(true);
      api.post('Sales/SaveLateReason', payload)
         .then((response) => {
            if (response.data.success) {
               toast.success("Late shipment reason created!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinLateRsn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinLateRsn(false);
         });
   }

   function UpdateLateReason() {
      setSpinLateRsn(true);
      api.post('Sales/SaveLateReason', lateRsn)
         .then((response) => {
            if (response.data.success) {
               toast.success("Late Ship Reason updated!")
               runQuery();
            } else {
               toast.error(response.data.message);
               setSpinLateRsn(false);
            }
         })
         .catch((error) => {
            api.catchHandler(error);
            toast.error(error);
            setSpinLateRsn(false);
         });
   }

   const ShowDeleteModal = () => {
      if (!lateRsn || lateRsn.reasonId === 0) {
         toast.error("Please select a reason");
         return;
      }
      confirmAlert({
         title: "Confirm Deletion",
         message: `Are you sure you want to delete the ${editRsn} reason?`,
         buttons: [
            { label: "Yes", onClick: () => { DeleteLateReason() }},
            { label: "No" }
         ]
      });
   }

   return (
      <Container fluid>
         <Row>
            <Col>
               <Fragment>
                  <ServiceThreadSpinner on={spinLateRsn}>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           {rsnList && rsnList.length ? (
                              <Table className="transparent-background my-0">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell noWrap h6" width="80px">
                                          Reason:
                                       </td>
                                       <td className="transparent-background" width="500px">
                                          <FilterSelect
                                             filterName="lateReason"
                                             options={rsnList}
                                             value={filterHelpers.getValue(filters, "lateReason")}
                                             onChangeCallback={e => onLateRsnChange(e)}
                                          />
                                       </td>
                                       <td className="transparent-background"></td>
                                    </tr>
                                 </tbody>
                              </Table>
                           ) : null}
                        </Col>
                     </Row>
               
                     {lateRsn && lateRsn.reasonId > 0 ? (
                        <div>
                           <Row className="px-0 py-0">
                              <Table className="transparent-background data-table">
                                 <tbody>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Deleting a reason that has late shipment records attached will set it to inactive.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td colSpan={5} className="transparent-background data-cell noWrap h6">
                                          Inactive reasons will not show up in late shipment entry options.
                                       </td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell width95px noWrap h6">
                                          Id: {lateRsn.reasonId}
                                       </td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Active: {lateRsn.isActive ? "Yes" : "No"}
                                       </td>
                                       <td colSpan={3} className="transparent-background data-cell"></td>
                                    </tr>
                                    <tr>
                                       <td className="transparent-background data-cell width40px"></td>
                                       <td className="transparent-background data-cell noWrap h6 width115px">
                                          Reason:
                                       </td>
                                       <td className="transparent-background data-cell width500px">
                                          <Input
                                             type="text"
                                             value={editRsn || ""}
                                             onChange={(e) => setEditRsn(e.target.value)}
                                             maxLength="100"
                                          />
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button
                                             title="Update"
                                             className="shredButton"
                                             onClick={() => onLateRsnUpdate()}
                                          >
                                             Update
                                          </Button>
                                       </td>
                                       <td className="transparent-background data-cell width115px">
                                          <Button
                                             title="Delete"
                                             className="shredButton"
                                             onClick={() => ShowDeleteModal()}
                                          >
                                             Delete
                                          </Button>
                                       </td>
                                       {!lateRsn.isActive ? (
                                          <td className="transparent-background data-cell">
                                             <Button
                                                title="Reactivate"
                                                className="shredButton"
                                                onClick={() => ActivateLateReason()}
                                             >
                                                Reactivate
                                             </Button>
                                          </td>
                                       ) : <td className="transparent-background data-cell"></td>}
                                    </tr>
                                 </tbody>
                              </Table>
                           </Row>
                        </div>
                     ) : null}

                     <br />
                     <br />
                     <hr/>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                        Add New Late Ship Reason
                        </Col>
                     </Row>
                     <Row className="px-2 py-2">
                        <Col xxl={{ offset: 0, size: 12 }}>
                           <Table className="transparent-background my-0">
                              <tbody>
                                 <tr>
                                    <td className="transparent-background data-cell noWrap h6" width="80px">
                                       Reason:
                                    </td>
                                    <td className="transparent-background" width="500px">
                                       <Input
                                          type="text"
                                          value={newRsn || ""}
                                          onChange={(e) => setNewRsn(e.target.value)}
                                          maxLength="100"
                                       />
                                    </td>
                                    <td className="transparent-background">
                                       <Button
                                          title="New Reason"
                                          className="shredButtonExcel ms-2"
                                          onClick={() => SaveNewRsn()}
                                       >
                                          Add Reason
                                       </Button>
                                    </td>
                                 </tr>
                              </tbody>
                           </Table>
                        </Col>
                     </Row>
                  </ServiceThreadSpinner>
               </Fragment>
            </Col>
         </Row>
      </Container>
   );
}
